// importing data
import { featureData } from './data';

// importing styles
import styles from './Features.module.scss';

const Features = () => {
    return (
        <section className={styles.features}>
            <div className="container">
                <ul>
                    {featureData.map((feature, index) => (
                        <li key={index}>
                            <img style={{ marginTop: '1rem' }} src={feature.image} alt="feature" />
                            <strong> {feature.title} </strong>
                            <span> {feature.subTitle} </span>
                        </li>
                    ))}
                </ul>
            </div>

        </section>
    );
}

export default Features;